var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        disabled: !_vm.hasContent,
        placement: "bottom",
        width: "200",
        trigger: "hover",
      },
    },
    [
      _c("el-image", {
        staticStyle: { width: "100%", height: "100%" },
        style: _vm.styleObj,
        attrs: { src: _vm.url, fit: "contain" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _vm.hasContent
            ? _c("el-image", {
                staticStyle: { width: "100%" },
                style: { height: _vm.height, ..._vm.styleObj },
                attrs: { src: _vm.url, fit: "contain" },
              })
            : [_vm._v("--")],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }